import { type ISchedule } from '@interface/ICommon';
import { formatTimeFromUTC } from '@utils/common';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

/* 
이벤트 타입
0 = 분쟁(contentType === 8), 진영전(contentType === 1), 
1 = 평화, 
2 = 길드, 
3 = 협동

컨텐츠 타입
1 = 지역 이벤트, 2 = 길드 지역 이벤트, 5 = 공성전, 6 = 기원석, 7 = 차원석, 8 = 필드 보스, 18 = 아크 보스
*/

const EventCard = ({ event }: { event: ISchedule }) => {
    return (
        <div
            className={classNames(
                {
                    'topic-combatregion': event.eventType === 0 && event.contentType === 8,
                    'topic-dominion': event.eventType === 0 && event.contentType === 1,
                    'topic-peaceregion': event.eventType === 1,
                    'topic-guildevent': event.eventType === 2,
                    'topic-cooperative': event.eventType === 3,
                },
                'card flex bg-bg border border-solid border-gray008 rounded-[4px] py-[12px] mb-[6px] lg:w-[360px]'
            )}
        >
            <div className="w-[70px] border-r border-solid border-gray008 text-center">
                <figure className="relative text-center mt-[-2px]">
                    <img className="inline-block w-[26px] h-[26px] m-[6px]" src={event.image} alt="" />
                    {event.contentType !== 5 && event.contentType !== 6 && event.contentType !== 7 && (
                        <span className="w-[18px] h-[18px] bg-white block absolute left-[50%] top-[50%] ml-[1px] border border-solid border-gray012 rounded-[100%] topic-bg bg-[length:10px_10px] bg-no-repeat bg-center"></span>
                    )}
                </figure>
                <span className="block text-sm12 text-black068 leading-[14px] !font-['Roboto']">
                    {formatTimeFromUTC(event.triggerTime)}
                </span>
            </div>
            <div className="w-[calc(100%-70px)]">
                <p className="ml-[10px] mr-[10px] mt-[4px] mb-[7px] text-lg16 text-black093 leading-tight">
                    {event.eventTypeName ? (
                        <em className="inline-block mr-[4px] text-lg15 leading-[15px] topic-color">{event.eventTypeName} </em>
                    ) : (
                        ''
                    )}
                    {event.name}
                </p>
                {event.contentType === 1 && <Desc event={event} />}
                {event.contentType === 2 && <Desc event={event} />}
                {event.contentType === 5 && <DescType5 event={event} />}
                {event.contentType === 6 && <DescType67 event={event} />}
                {event.contentType === 7 && <DescType67 event={event} />}
                {event.contentType === 8 && <Desc event={event} />}
                {event.contentType === 18 && <Desc event={event} />}
            </div>
        </div>
    );
};
export default EventCard;

const Desc = ({ event }: { event: ISchedule }) => {
    const { t } = useTranslation();

    return (
        <div>
            <span className="text-base text-black045 leading-[14px] ml-[10px] block">{event.locationName}</span>
            <span className="text-base text-black045 leading-[14px] ml-[10px]">
                {t('I015')} {event.minLevel}~{event.maxLevel}
            </span>
        </div>
    );
};

const DescType5 = ({ event }: { event: ISchedule }) => (
    <div>
        <span className="text-base text-black045 leading-[14px] ml-[10px]">{event.locationName}</span>
    </div>
);

const DescType67 = ({ event }: { event: ISchedule }) => {
    const { t } = useTranslation();

    return (
        <div>
            <span className="text-base text-black045 leading-[14px] ml-[10px]">{t('I016')}</span>
            <span className="text-base text-black045 leading-[14px] ml-[10px]">{event.guildName ? event.guildName : t('I017')}</span>
        </div>
    );
};
